import { type CoreAddress } from '@flecto/types'

export function useAddressInline() {
  return (address: CoreAddress, withLabel = false): string => {
    const inline: string[] = []

    const {
      address_city = '',
      address_country_name = '',
      address_postal_code = '',
      address_street = '',
      label = '',
    } = address || {}

    if (withLabel && label) {
      inline.push(label)
    }

    if (address_street) {
      inline.push(address_street)
    }

    if (address_city) {
      inline.push(address_city)
    }

    if (address_postal_code) {
      inline.push(address_postal_code)
    }

    if (address_country_name) {
      inline.push(address_country_name)
    }

    return inline.join(', ')
  }
}
